export const blockIconsCommunicationSmsNew = (
	<span className='material-symbols-outlined'>sms</span>
);
